import Vue from 'vue';
import VueResource from 'vue-resource';

Vue.use(VueResource);

export const fncPopulatePrivList = ({ commit, dispatch, state, rootState }, payload) => {
	if (state.privList.length == 0 || (payload != undefined && (payload.refresh == true || payload.reload == true))) {
		var objAuth = JSON.parse(rootState.objAuthorize);
		var privDetails = { a: 'getAll', manu: objAuth.manufacturer };
		Vue.http.get(window.location.protocol + process.env.API_ENDPOINT + 'Privilege.php', { params: privDetails }, rootState.headerDetails)
			.then(response => {
				return response.json();
			}, error => {
				var snackDetails = { color: 'error', message: 'An error occured while trying to retrieve the privileges list', display: true };
				commit('setSnack', snackDetails);
			}).then(data => {
				commit('setPrivList', data);
				if (payload != undefined && payload.reload == true) {
					var snackDetails = { color: 'success', message: 'Privilege reload successfull', display: true };
					commit('setSnack', snackDetails);
				}
			});
	}
}

export const fncDeletePriv = ({commit, dispatch, state, rootState}, payload) => {
	var privDetails = {id: payload.privId};
	Vue.http.post(window.location.protocol + process.env.API_ENDPOINT + 'Privilege.php?a=delete', privDetails, rootState.headerDetails)
		.then(response => {
			return response.json();
		}, error => {
			var snackDetails = {color: 'error', message: 'An error occured while trying to remove the privilege', display: true};
			commit('setSnack', snackDetails);
		}).then(data => {
			var snackDetails = {color: 'success', message: 'The privilege was removed successfully', display: true};
			commit('setSnack', snackDetails);
			dispatch({
				type: 'fncPopulatePrivList',
                refresh: true
			})
		});
}

export const fncAddPriv = ({commit, dispatch, state, rootState}, payload) => {
	commit('setRunAdd', true);
	var objAuth = JSON.parse(rootState.objAuthorize);
	var privDetails = {key: payload.settings.privKey, description: payload.settings.privDescription, manu: objAuth.manufacturer, current_user_id: objAuth.manufacturer};
	Vue.http.post(window.location.protocol + process.env.API_ENDPOINT + 'Privilege.php?a=create', privDetails, rootState.headerDetails)
		.then(response => {
			return response.json();
		}, error => {
			var snackDetails = {color: 'error', message: 'An error occured while trying to add the privilege', display: true};
			commit('setSnack', snackDetails);
		}).then(data => {
			commit('setRunAdd', false);
			var snackDetails = {color: 'success', message: 'The privilege was added successfully', display: true};
			commit('setSnack', snackDetails);
			commit('hideModal');
			dispatch({
				type: 'fncPopulatePrivList',
				refresh: true
			})
		});
}

export const fncEditPriv = ({commit, dispatch, state, rootState}, payload) => {
	commit('setRunAdd', true);
	var privDetails = {
		id: payload.editPriv.id,
		key: payload.editPriv.priv_key,
		description: payload.editPriv.description
	};
	Vue.http.post(window.location.protocol + process.env.API_ENDPOINT + 'Privilege.php?a=edit', privDetails, rootState.headerDetails)
		.then(response => {
			return response.json();
		}, error => {
			var snackDetails = {color: 'error', message: 'An error occured while trying to remove the privilege', display: true};
			commit('setSnack', snackDetails);
		}).then(data => {
			if( data.error === '' || data.error === undefined ) {
				commit('setRunAdd', false);
				var snackDetails = {color: 'success', message: 'The privilege was updated successfully', display: true};
				commit('setSnack', snackDetails);
				commit('hideModal');
				dispatch({
					type: 'fncPopulatePrivList',
					refresh: true
				})
			} else {
				commit('setRunAdd', false);
				var snackDetails = {color: 'error', message: 'An error occured while trying to update the privilege', display: true};
				commit('setSnack', snackDetails);
				commit('hideModal');
				dispatch('fncPopulatePrivList');
			}

		});
}
